import React from 'react'
import { Empty, EmptyDetail } from 'prospect-path-components';
import { Button } from 'prospect-path-base';
import { history } from '../../store';

class BlankProductPage extends React.Component
{
  render() {
    return (
      <Empty
        style={{ marginBottom: '2.5rem' }}
        headerImage={(
          <svg width="100%" height="56" viewBox="0 0 400 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs />
            <g opacity=".5">
              <rect x="245.5" y="4.5" width="153.286" height="47" rx="11.5" fill="#fff" stroke="#E4E4E4" />
              <circle cx="269" cy="28" r="13.714" fill="#F8F8F8" />
              <rect x="293" y="16.857" width="96" height="8.571" rx="4.286" fill="#BBB" />
              <rect x="293" y="30.571" width="68.571" height="8.571" rx="4.286" fill="#EBEBEB" />
              <path fillRule="evenodd" clipRule="evenodd" d="M262.143 24.143a3 3 0 013-3h7.714a3 3 0 013 3v7.714a3 3 0 01-3 3h-7.714a3 3 0 01-3-3v-7.714zm1.142 7.45c0-.102.054-.196.142-.246l6.531-3.733a2 2 0 012.407.323l1.932 1.932c.267.267.416.628.416 1.004v.435a2.406 2.406 0 01-2.406 2.406h-6.901a2.12 2.12 0 01-2.121-2.122zm2.859-4.736a1.714 1.714 0 100-3.428 1.714 1.714 0 000 3.428z" fill="#BBB" />
            </g>
            <g opacity=".5">
              <rect x=".5" y="4.5" width="153.286" height="47" rx="11.5" fill="#fff" stroke="#E4E4E4" />
              <circle cx="24" cy="28" r="13.714" fill="#F8F8F8" />
              <rect x="48" y="16.857" width="96" height="8.571" rx="4.286" fill="#BBB" />
              <rect x="48" y="30.571" width="68.571" height="8.571" rx="4.286" fill="#EBEBEB" />
              <path fillRule="evenodd" clipRule="evenodd" d="M17.143 24.143a3 3 0 013-3h7.714a3 3 0 013 3v7.714a3 3 0 01-3 3h-7.714a3 3 0 01-3-3v-7.714zm1.142 7.45c0-.102.054-.196.142-.246l6.531-3.733a2 2 0 012.407.323l1.932 1.932c.267.267.416.628.416 1.004v.435a2.406 2.406 0 01-2.406 2.406h-6.9a2.122 2.122 0 01-2.122-2.122zm2.859-4.736a1.714 1.714 0 100-3.43 1.714 1.714 0 000 3.43z" fill="#BBB" />
            </g>
            <rect x="110.5" y=".5" width="179" height="55" rx="11.5" fill="#fff" stroke="#E4E4E4" />
            <circle cx="138" cy="28" r="16" fill="#F8B400" fillOpacity=".08" />
            <rect x="166" y="15" width="112" height="10" rx="5" fill="#BBB" />
            <rect x="166" y="31" width="80" height="10" rx="5" fill="#EBEBEB" />
            <path fillRule="evenodd" clipRule="evenodd" d="M130 23a3 3 0 013-3h10a3 3 0 013 3v10a3 3 0 01-3 3h-10a3 3 0 01-3-3V23zm1.332 9.191a.33.33 0 01.166-.287l7.841-4.48a2.001 2.001 0 012.407.322l2.434 2.435c.311.31.485.732.485 1.171v.507a2.807 2.807 0 01-2.807 2.807h-8.051a2.475 2.475 0 01-2.475-2.475zm3.336-5.525a2 2 0 100-4 2 2 0 000 4z" fill="#F8B400" />
          </svg>
        )}
      >
        <EmptyDetail
          title="Add your products"
          subtitle="Add your software products to reach best-fit software buyers"
          action={(
            <div style={{
              display: 'flex',
              justifyContent: 'center'
            }}>
              <Button
                size="small"
                color="primary"
                onClick={() => history.push('/products/add')}
              >
                Add a product
              </Button>
            </div>
          )}
        />
      </Empty>
    );
  }
}

export default BlankProductPage;
